import { type FC } from 'react';
import {
  type UiStackProps,
  UiStack,
  uiStyles, UiFlex,
} from '@/lib/ui';

export interface FieldColumnProps extends UiStackProps {
  width?: UiStackProps['width']
  title?: string
}

const FieldColumn: FC<FieldColumnProps> = ({
  // width = '720px',
  title = null,
  children,
  ...props
}) => {
  return (
    <UiStack
      // bgColor={'whiteAlpha.600'}
      spacing={8}
      // maxWidth={width}
      // minWidth={width}
      flexGrow={1}
      // bgColor={'blackAlpha.50'}
      borderRadius={uiStyles.borderRadius}
      borderWidth={'1px'}
      borderColor={'gray.300'}
      borderStyle={'solid'}
      alignItems={'stretch'}
      justifyContent={'flex-start'}
      p={8}
      {...props}
    >
      {children}
    </UiStack>
  );
};

export default FieldColumn;
